export class GuideTourValidationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'GuideTourValidationError'
  }
}
